import $ from 'jquery';
import 'bootstrap-datepicker';
import isSameDay from 'date-fns/isSameDay';
import isBefore from 'date-fns/isBefore';
import dateAdd from 'date-fns/add';

const $document = $(document);
const $window = $(window);

$('.js-booking-datepicker').each(function (index, datepicker) {
  let $datepicker = $(datepicker);
  let id = $datepicker.attr('id');
  $datepicker
    .datepicker({
      container: `[data-id="${id}"]`,
      autoclose: true,
      format: 'yyyy-mm-dd',
      maxViewMode: 2,
      todayHighlight: true,
      templates: {
        leftArrow:
          '<button class="datepicker-button" type="button"><svg class="datepicker-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.286 15.106"><path d="M.792 7.553l7.994 6.502V1.05L.792 7.554z"/></svg></button>',
        rightArrow:
          '<button class="datepicker-button" type="button"><svg class="datepicker-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.286 15.106"><path d="M8.494 7.553L.5 1.05v13.005l7.994-6.502z"/></svg></button>',
      },
      beforeShowDay: function (date) {
        if (isSameDay(date, this.startDate)) {
          return 'start';
        }
      },
    })
    .on('changeDate', function (event) {
      let $this = $(this);
      let $form = $this.closest('.js-booking-form');
      let $formCheckin = $form.find('[name="checkinDate"]');
      let $formCheckout = $form.find('[name="checkoutDate"]');

      const checkinDate = $formCheckin.datepicker('getDate');
      const checkoutDate = $formCheckout.datepicker('getDate');

      if (!checkinDate) {
        return;
      }

      const checkoutStartDate = dateAdd(checkinDate, { days: 1 });
      $formCheckout.addClass('has-start-date');
      $formCheckout.datepicker('setStartDate', checkoutStartDate);

      // Ensure that the checkoutDate defaults to checkinDate + 1
      if (!checkoutDate) {
        $formCheckout.datepicker('setDate', checkoutStartDate);
      }

      // Ensure that the checkoutDate is after the checkinDate
      if (isBefore(checkoutDate, checkinDate)) {
        $formCheckout.datepicker('setDate', checkoutStartDate);
      }
    });
});

let $bookingButton = $('.js-booking-button');
const DISTANCE_THRESHOLD = 500;

if ($document.scrollTop() > DISTANCE_THRESHOLD) {
  $bookingButton.addClass('is-visible');
}

$window.on('scroll', function () {
  if (
    $document.scrollTop() >= DISTANCE_THRESHOLD &&
    !$bookingButton.hasClass('is-visible')
  ) {
    $bookingButton.addClass('is-visible');
  } else if (
    $document.scrollTop() < DISTANCE_THRESHOLD &&
    $bookingButton.hasClass('is-visible')
  ) {
    $bookingButton.removeClass('is-visible');
  }
});
